import React, { Component } from "react";

import Paso1 from "./Paso1";
import Paso2 from "./Paso2";
import Paso3 from "./Paso3";
import Titulo from "../../../generico/TituloPagina";
import StepWizard from "react-step-wizard";

export default class TransferCuentasPropias extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.paso1 = React.createRef();
    this.paso2 = React.createRef();
    this.paso3 = React.createRef();
  }
  resetState = () => {
    this.setState(this.getInitialState());
  };
  getInitialState = () => ({
    cuentaOrigen: {},
    cuentaDestino: {},
    importe: 0,
    nroOperacion: "",
    itemsConfirm: [],
  });
  returnDataPaso1(
    _cuentaOrigen,
    _cuentaDestino,
    _importe,
    _itemsConfirm,
    _detalleCuenta,
    _cuentaOrigenSelected,
    _cuentaDestinoSelected
  ) {
    this.setState({
      cuentaOrigen: _cuentaOrigen,
      cuentaDestino: _cuentaDestino,
      importe: _importe,
      itemsConfirm: _itemsConfirm,
      detalleCuenta: _detalleCuenta,
      cuentaOrigenSelected: _cuentaOrigenSelected,
      cuentaDestinoSelected:_cuentaDestinoSelected
    });
  }

  returnDataPaso2(_nroOperacion) {
    this.setState({
      nroOperacion: _nroOperacion,
    });
  }

  returnDataPaso3() {
    this.initDataChildren();
  }
  initDataChildren() {
    this.paso1.current.initData();
    this.paso2.current.resetState();
  }
  onStepChange = (stats) => {
    if (stats.previousStep === 2) {
      this.paso1.current.checkGrilla();
    }
  };
  componentDidMount() {}

  render() {
    return (
      <div className="content-wrapper">
        <Titulo texto="Cuentas Propias" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card" >
                  <div className="card-body" style={{zIndex: 0}}>
                    <StepWizard
                      onStepChange={this.onStepChange}
                      transitions="none"
                    >
                      <Paso1
                        ref={this.paso1}
                        returnDataPaso1={this.returnDataPaso1.bind(this)}
                      />
                      <Paso2
                        ref={this.paso2}
                        cuentaOrigen={this.state.cuentaOrigen}
                        cuentaDestino={this.state.cuentaDestino}
                        importe={this.state.importe}
                        itemsConfirm={this.state.itemsConfirm}
                        cuentaOrigenSelected={this.state.cuentaOrigenSelected}
                        cuentaDestinoSelected={this.state.cuentaDestinoSelected}
                        detalleCuenta={this.state.detalleCuenta}
                        nroOperacion={this.state.nroOperacion}
                        returnDataPaso2={this.returnDataPaso2.bind(this)}
                      />
                      <Paso3
                        ref={this.paso3}
                        cuentaOrigen={this.state.cuentaOrigen}
                        cuentaDestino={this.state.cuentaDestino}
                        itemsConfirm={this.state.itemsConfirm}
                        cuentaOrigenSelected={this.state.cuentaOrigenSelected}
                        cuentaDestinoSelected={this.state.cuentaDestinoSelected}
                        detalleCuenta={this.state.detalleCuenta}
                        importe={this.state.importe}
                        nroOperacion={this.state.nroOperacion}
                        returnDataPaso3={this.returnDataPaso3.bind(this)}
                      />
                    </StepWizard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
